import { Box } from '@material-ui/core';
import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const StyledBoxContainer = styled(Box)`
    ${media.mediumDevice`
        padding : ${(props) => props.mdPadding}
    `}
`;

export const StyledBox = styled(Box)`
    padding-right: ${(props) => props.ldPaddingRight};
    ${media.mediumDevice`
        padding-right : ${(props) => props.mdPaddingRight}
    `};
    @media screen and (min-width: 768px) and (max-width: 768px) and (orientation: portrait){
     margin-left: ${({ ipadMarginLeft }) => (ipadMarginLeft ? ipadMarginLeft : '')};

    }

`;
